module.exports = __webpack_public_path__ + "img/accountLogo.679172c5.png";